// import employeeLogo from "../../images/employee.png";
// import jsPDF from "jspdf";
// import moment from "moment";

// export const CombinedSalesPrint  = ({ search, items, state }) => {
//   console.log('items', items)
// //   const totalQuantity = items?.flatMap((item) => {
// //     return item?.items?.map(subItem => Number(subItem.quantity) ?? 0);
// //   }) ?? [];
// //   console.log('u', totalQuantity)

// //   const totalQuantitySum =    totalQuantity.reduce((acc ,curr ) => acc + Number(curr) ,0)
//   let doc = new jsPDF();
//   jsPDF.autoTableSetDefaults({
//     theme: "plain",
//     headStyles: { fontStyle: "bold" },

//     margin: { left: 8, right: 8, bottom: 10 },
//     bodyStyles: { color: "rgba(0, 0, 0, 0.87)", fontStyle: "bold" },
//   });
//   let pageWidth =
//     doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

//   let img = new Image();

//   let baseUrl = localStorage.getItem("base_url");

//   if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
//     let snapshot = employeeLogo;
//     img.src = snapshot;
//   } else {
//     let snapshot = localStorage.getItem("base_url");
//     img.src = snapshot;
//   }

//   doc.addImage(img, "png", 5, 5, 30, 30);

//   doc.setFontSize(18);
//   doc.setFontStyle("bold");
//   doc.text(localStorage.getItem("company"), 90, 22);
//   doc.setFontSize(26);
//   doc.text("REPORT DETAIL", 80, 35);

//   doc.setFontSize(12);
//   doc.setFontStyle("normal");

//   doc.text("From:", 150, 45);
//   doc.text(search.startDate, 165, 45);

//   doc.text("To:", 150, 55);
//   doc.text(search.endDate, 165, 55);

//   doc.setFontSize(14);
//   doc.setFontStyle("bold");

//   doc.setFontSize(12);
//   doc.text("SHOP", 21, 48);

//   doc.setFontStyle("normal");
//   doc.text(localStorage.getItem("company") || "", 20, 55);
//   doc.text(localStorage.getItem("address") || "", 20, 62);
//   doc.text(localStorage.getItem("phone") || "", 20, 69);
//   let rows = [];
//   let col = ["#", "Credit","Profit", "Type", "Created"];
//   items?.datebook?.map((item, i) => {
//     let quantity;
//     quantity = item?.items?.map((item)=> {
//       return item?.quantity
//     })
//     let temp = [
//       item?.billNumber,
//       item?.total,
//       item?.billProfit,
//       "Bill",
//       moment.unix(item?.created_at).format("DD-MM-YYYY"),
//     ];
//     rows.push(temp);
//   });

//   doc.autoTable(col, rows, { startY: 100 });
//   var finalY = doc.lastAutoTable.finalY;
//   doc.setFontSize(14);
//   doc.text("Total Amount", 120, finalY + 15);
//   doc.text(state.credit.toString() || "", 168, finalY + 15);
//   doc.text("Total Profit", 120, finalY + 24);
//   doc.text(state.profit.toString() || "", 168, finalY + 24);
// //   doc.text("Total Remaining", 120, finalY + 32);
// //   doc.text(state.totalRemaining.toString() || "", 168, finalY + 32);
// //   doc.text("Total Quantity", 120, finalY + 40);
// //   doc.text(totalQuantitySum.toString() || "", 168, finalY + 40);

//   doc.setFontSize(10);

//   doc.text("Powered by www.hardwarepakistan.com", pageWidth / 2, 285, {
//     align: "center",
//   });
//   doc.text("0342-5588269", pageWidth / 2, 290, {
//     align: "center",
//   });

//   if (window.innerWidth <= 600) {
//     doc.save("reciept");
//   } else {
//     doc.autoPrint();
//     window.open(doc.output("bloburl"), "_blank");
//   }
// };











import employeeLogo from "../../images/employee.png";
import moment from "moment";
import html2pdf from "html2pdf.js";

export const CombinedSalesPrint = ({ search, items, state }) => {
  console.log("search", search)
  console.log("items", items)
  console.log("state", state)

  // Build HTML content for PDF generation
  const htmlContent = document.createElement("div");
  htmlContent.innerHTML = `
    <div style="padding: 10px; font-family: Arial, sans-serif;">
      <div style="display: flex; align-items: center;">
        <img src="${localStorage.getItem("base_url") || employeeLogo}" width="30" height="30" style="margin-right: 10px;" />
        <h2>${localStorage.getItem("company")}</h2>
      </div>
      <h1 style="text-align: center;">COMBINED SALES REPORT</h1>
      
      <p>From: ${search.startDate}</p>
      <p>To: ${search.endDate}</p>
      
      <h3>SHOP</h3>
      <p>${localStorage.getItem("company") || ""}</p>
      <p>${localStorage.getItem("address") || ""}</p>
      <p>${localStorage.getItem("phone") || ""}</p>

      <table border="1" cellpadding="5" cellspacing="0" width="100%" style="margin-top: 20px;">
        <thead>
          <tr>
            <th>#</th>
            <th>Customer</th>
            <th>Credit</th>
            <th>Profit</th>
            <th>Type</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          ${items?.datebook?.map((item, i) => `
            <tr>
              <td>${item?.billNumber}</td>
              <td>${item?.customer}</td>
              <td>${item?.total}</td>
              <td>${item?.billProfit}</td>
              <td>Bill</td>
              <td>${moment.unix(item.created_at).format("DD-MM-YYYY")}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <p style="text-align: right; font-size: 14px; margin-top: 10px;">
        Total Amount: ${state.credit || ""}
      </p>
      <p style="text-align: right; font-size: 14px;">
        Total Profit: ${state.profit || ""}
      </p>

    </div>
  `;

  const options = {
    margin: 0.5,
    filename: "combined_sales_report.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // Generate PDF and open in a new tab with print preview
  html2pdf()
    .from(htmlContent)
    .set(options)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100); // Wait a short moment before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
};
